import { createRoot } from "react-dom/client";
import App from "~/app/App";
import { checkIsProduction, initDatadog } from "~/shared/lib/datadog";
import { initializeI18n } from "~/shared/lib/i18n";

if (checkIsProduction()) {
  initDatadog();
}

initializeI18n();

createRoot(document.getElementById("root")!).render(<App />);

if (import.meta.env.DEV) {
  import("react-grab");
}
